import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import { classNames } from '../../utils/tailwind/classNames';

interface RecommendationsSkeletonProps {
    isDrawer?: boolean;
}

export const RecommendationsSkeleton: FC<RecommendationsSkeletonProps> = ({ isDrawer }) => (
    <div
        className={classNames('w-full bg-white flex flex-col', {
            'pb-8 pt-1 gap-5': isDrawer,
            'py-4 gap-6': !isDrawer,
        })}
        data-testid="recommendation-skeleton"
    >
        <Skeleton
            className={classNames('max-w-full w-[300px]', {
                'h-7': isDrawer,
                'h-8': !isDrawer,
            })}
        />
        <Skeleton
            className={classNames('w-full', {
                'h-[146px] md:h-[154px]': isDrawer,
                'h-[320px]': !isDrawer,
            })}
        />
    </div>
);

RecommendationsSkeleton.defaultProps = {
    isDrawer: false,
};
